<template>
    <div class="help-fab" @click="openWhatsApp">
        <div class="bubble">{{ $t('needHelp') }}</div>
        <div class="icon">
            <!-- <i class="el-icon-question"></i> -->
            <img src="@/assets/img/whatsapp.png" />
            <!-- 或使用自定义图标 -->
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        openWhatsApp() {
            window.open(
                'https://chat.whatsapp.com/GjqCU673RGNDF2YjL1Bzul',
                '_blank'
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.help-fab {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer;
    z-index: 9999;

    .icon {
        width: 56px;
        height: 56px;
        background: #25d366; // WhatsApp 品牌色
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
        transition: transform 0.2s;

        i {
            color: white;
            font-size: 28px;
        }
        img {
            height: 28px;
            width: 28px;
        }

        &:hover {
            transform: scale(1.1);
        }
    }

    .bubble {
        position: absolute;
        right: 70px;
        top: 50%;
        transform: translateY(-50%);
        background: white;
        padding: 8px 16px;
        border-radius: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        white-space: nowrap;
        opacity: 0;
        transition: opacity 0.3s;
    }

    &:hover .bubble {
        opacity: 1;
    }
}

@media (max-width: 768px) {
    .help-fab {
        bottom: 60px;
        right: 20px;

        .icon {
            width: 48px;
            height: 48px;

            i {
                font-size: 24px;
            }
            img {
                height: 24px;
                width: 24px;
            }
        }
        .bubble {
            display: none;
        }
    }
}
</style>